module.exports = __webpack_public_path__ + "img/NDZ_Footer_Logo.d59ba86d.svg";